// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3C6WA","inputWrap":"Table_inputWrap__3vaw3","col":"Table_col__2tuaW","bmiTooltip":"Table_bmiTooltip__KAMjo"};